import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import MuiButton from "../../components/basicComponent/MuiButton";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { UtilService } from "../../services/shared/UtilService";
import { msgTypes } from "../../constants/msgTypes";
import { Pagination } from "@mui/material";
import { formatDate, replaceEMTwithEWTS } from "../../constants/helper";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ScheduleIcon from "@mui/icons-material/Schedule";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
import ActivityIndicator from "../../components/basicComponent/ActivityIndicator";
import { useGlobalState } from "../../services/context/AuthContext";

// [Booking interface and other components remain unchanged]

const TableHead: React.FC = () => (
  <thead>
    <tr>
      <th className="">
        <span className="sort">ID</span>
      </th>
      <th>
        <span className="sort">Booking Date</span>
      </th>
      <th>
        <span className="sort">Flight</span>
      </th>
      <th>
        <span className="sort">Route</span>
      </th>
      <th>
        <span className="sort">Price</span>
      </th>
      <th>
        <span className="sort">Pax</span>
      </th>
      <th>
        <span className="sort">Share</span>
      </th>
      <th>
        <span className="sort">Download</span>
      </th>
    </tr>
  </thead>
);

interface BookingTableProps {
  bookings: any[];
  showActions?: boolean;
  loading?: boolean;
}

const BookingTable: React.FC<BookingTableProps> = ({
  bookings,
  showActions = true,
  loading,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [popoverPassengers, setPopoverPassengers] = useState<any[]>([]);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { showInput } = useSweetAlert();

  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement>,
    passengers: any[]
  ) => {
    setAnchorEl(event.currentTarget);
    setPopoverPassengers(passengers);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setIsExpanded(false);
  };
  console.log("bookings", bookings);

  const navigate = useNavigate();
  const downloadTicket = async (id: string, passenger: any[]) => {
    try {
      const response = (await UtilService.downloadTicket(id)) as any;
      // Create a blob link
      const blob = new Blob([response?.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link and simulate click
      const link = document.createElement("a");
      link.href = blobUrl;

      // Optional: Use Content-Disposition or fallback filename
      const contentDisposition = response.headers["content-disposition"];
      const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
      const fileName =
        passenger.length > 0
          ? `${passenger?.[0]?.title} ${passenger?.[0]?.firstName} ${passenger?.[0]?.lastName}.pdf`
          : "ticket.pdf";
      const cleanFileName = fileName.replace(/[^\w.-]/g, " ");
      link.download = cleanFileName;

      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.log("error while download ticket", error);
    }
  };
  const handleSendEmail = (id: string) => {
    showInput("Enter your email address", "yourname@example.com", "email").then(
      async (result) => {
        if (result.isConfirmed && result.value) {
          const payload = {
            booking_txn_id: id,
            email: result.value,
          };
          const res = await UtilService.sendTicketViaMail(payload);
        }
      }
    );
  };
  return (
    <div className="scrollable-x-auto">
      <table className="table table-border">
        <TableHead />
        {loading ? (
          <tbody>
            <tr>
              <td colSpan={8}>
                <div className="d-flex justify-content-center align-items-center py-4">
                  <ActivityIndicator />
                </div>
              </td>
            </tr>
          </tbody>
        ) : bookings?.length > 0 ? (
          <tbody>
            {bookings?.map((booking: any, index: number) => {
              const outbound = booking.passengers.find(
                (p: any) => p.tripType === "OutBound"
              );
              const inbound = booking.passengers.find(
                (p: any) => p.tripType === "InBound"
              );
              return (
                <tr key={index}>
                  <td>
                    <Typography
                      aria-owns={anchorEl ? "mouse-over-popover" : undefined}
                      aria-haspopup="true"
                      onMouseEnter={(e) =>
                        handlePopoverOpen(e, booking.passengers)
                      }
                      onMouseLeave={handlePopoverClose}
                      onClick={() => {
                        navigate("/flightbookinghistorydetail", {
                          state: {
                            data: booking,
                          },
                        });
                      }}
                    >
                      <span className="sort ">
                        {replaceEMTwithEWTS(booking.transactionScreenId)}
                      </span>
                    </Typography>
                    <Popover
                      id="mouse-over-popover"
                      sx={{ pointerEvents: "none" }}
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      onClose={handlePopoverClose}
                      disableRestoreFocus
                      PaperProps={{
                        sx: {
                          boxShadow: "none", // ✅ removes the shadow
                          border: "1px solid #ddd", // optional: adds subtle border
                          backgroundColor: "#fff", // optional: set background if needed
                        },
                      }}
                    >
                      <Typography sx={{ p: 1 }}>
                        {(isExpanded
                          ? popoverPassengers
                          : popoverPassengers.slice(0, 1)
                        ).map((p, idx) => (
                          // <div key={idx} className="mb-2 border-b pb-1">
                          //   <div>Title: {p.title}</div>
                          //   <div>First Name: {p.firstName}</div>
                          //   <div>Last Name: {p.lastName}</div>
                          //   <div>Type: {p.passengerType}</div>
                          //   <div className="text-muted">DEL → BOM</div>
                          // </div>
                          <div className="" style={{ fontSize: "12px" }}>
                            <div className="mb-1">
                              <strong>
                                {p.title} {p.firstName} {p.lastName}
                              </strong>
                            </div>
                            <div className="text-muted">DEL → BOM</div>
                          </div>
                        ))}
                      </Typography>
                    </Popover>
                  </td>
                  <td>
                    <span className="sort ">
                      {formatDate(booking?.bookingDate)}
                    </span>
                  </td>
                  <td>
                    <div
                      style={{ display: "inline-block", textAlign: "start" }}
                    >
                      <div>
                        <span className="sort ">
                          <span className=""> </span> {outbound?.airlineCode}
                          {"-"}
                          {outbound?.airlineNumber} on{" "}
                          {formatDate(outbound?.arrivalDate)}
                        </span>
                      </div>
                      {inbound && (
                        <div>
                          <span className="sort ">
                            <span className="pe-1"> Return:</span>
                            {inbound?.airlineCode}
                            {"-"} {inbound?.airlineNumber} on{" "}
                            {formatDate(inbound?.arrivalDate)}
                          </span>
                        </div>
                      )}
                    </div>
                  </td>
                  <td>
                    <div
                      style={{ display: "inline-block", textAlign: "start" }}
                    >
                      <span className="sort">
                        {outbound?.origin}
                        <i className="fa-solid fa-plane ms-1"></i>
                        {outbound?.destination}
                      </span>
                      <br />
                      {inbound && (
                        <div className="sort">
                          Return: {inbound?.origin}
                          <i className="fa-solid fa-plane ms-1"></i>
                          {inbound?.destination}
                        </div>
                      )}
                    </div>
                  </td>
                  <td>
                    <span className="sort">
                      {currency} {parseFloat(booking?.payAmount || "0") || 0}
                    </span>
                  </td>
                  <td>
                    <span className="sort ">
                      {booking.fareType === "Oneway"
                        ? booking?.passengers?.length
                        : booking?.passengers?.length / 2}
                    </span>
                  </td>
                  <td>
                    <Tooltip
                      title={
                        <>
                          {/* <div className="flex items-center gap-2 ">
                            <WhatsAppIcon fontSize="small" />
                            <span className="text-decoration-underline cursor-pointer">
                              WhatsApp
                            </span>
                          </div> */}
                          <div
                            className="flex items-center gap-2  "
                            onClick={() =>
                              handleSendEmail(booking.bookingTxnId)
                            }
                          >
                            <MailOutlineIcon fontSize="small" />
                            <span className="text-decoration-underline cursor-pointer">
                              Mail
                            </span>
                          </div>
                        </>
                      }
                    >
                      <button className="btn btn-primary btn-sm">
                        <i className="fa-solid fa-share"></i> Share
                      </button>
                    </Tooltip>
                  </td>
                  <td>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() =>
                        downloadTicket(
                          booking.bookingTxnId,
                          booking?.passengers
                        )
                      }
                    >
                      <i className="fa-solid fa-download"></i> Download
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td colSpan={8}>
                {/* Adjust the number to match your column count */}
                <div className="d-flex flex-column align-items-center justify-content-center py-4">
                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded-circle mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <img
                      src="media/images/remove-folder.png"
                      alt="remove-folder"
                      style={{ maxWidth: "40px", maxHeight: "40px" }}
                    />
                  </div>
                  <h5 className="text-muted mb-0 fw-bold fs-5">
                    No Booking History Found
                  </h5>
                </div>
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
};

const FilterSection: React.FC = () => (
  <div className="row w-50 flight-boking-input">
    <div className="col-md-6">
      <MuiSearchSelect
        placeholder="id, airport, email, name..."
        options={[]}
        onChange={() => {}}
        value=""
        label="Filter by Action"
      />
    </div>
    <div className="col-md-6">
      <div className="user-button my-0">
        <MuiButton
          style={{ width: "-webkit-fill-available" }}
          className="main-btn get-btn"
          variant="contained"
          size="large"
          type="submit"
          label="Submit"
        />
        <MuiButton
          style={{ width: "-webkit-fill-available" }}
          className="clear-btn w-full"
          label="Reset"
          type="reset"
        />
      </div>
    </div>
  </div>
);

const FlightBookingHistory: React.FC = () => {
  const location = useLocation();
  const [value, setValue] = useState<number>(0);
  const [bookingData, setBookingData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Set this to your preferred value

  useEffect(() => {
    getBookingHistory(0);
  }, []);
  const formatDateToYYYYMMDD = (date: Date) => date.toISOString().split("T")[0];
  const getBookingHistory = async (tabIndex: number) => {
    setLoading(true);
    try {
      const today = new Date();
      const formattedToday = formatDateToYYYYMMDD(today);

      let fromDate = "";
      let toDate = "";
      let dataType = "";
      if (tabIndex === 0) {
        fromDate = formattedToday;
        toDate = formattedToday;
        dataType = "current";
      } else if (tabIndex === 1) {
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        fromDate = formatDateToYYYYMMDD(tomorrow);
        dataType = "upcoming";
      } else if (tabIndex === 2) {
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        toDate = formatDateToYYYYMMDD(yesterday);
        dataType = "past";
      }

      const response = await UtilService.getBookings({
        date_type: dataType,
      });

      if (response?.statusMsg === msgTypes.SUCCESS.msg) {
        setLoading(false);
        setBookingData(response?.data);
        setCurrentPage(1); // Reset pagination
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching booking history:", error);
    }
  };

  const tabLabels: string[] = [
    "Today’s Travel",
    "Upcoming Travel",
    "Past Travel",
  ];

  const paginatedBookings = bookingData?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const icons = [
    <EventNoteIcon />, // for tab 0
    <ScheduleIcon />, // for tab 1
    <FlightTakeoffIcon />, // for tab 2
  ];

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");
    if (tab) {
      setValue(Number(tab));
      getBookingHistory(Number(tab));
    }
  }, [location]);

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header flex-wrap">
              <h3 className="card-title">Booking History</h3>
            </div>

            <div className="card card-grid min-w-full ancillary-services-card">
              <Box sx={{ width: "100%" }}>
                <Tabs
                  value={value}
                  onChange={(e, newValue) => {
                    setValue(newValue);
                    getBookingHistory(newValue);
                  }}
                  variant="scrollable"
                  scrollButtons="auto" // show only if overflow
                  allowScrollButtonsMobile // show on mobile
                  aria-label="Booking Tabs"
                >
                  {tabLabels.map((label, index) => (
                    <Tab
                      label={label}
                      key={index}
                      icon={icons[index]}
                      iconPosition="start"
                    />
                  ))}
                </Tabs>
                {tabLabels.map((label, index) => (
                  <div
                    key={index}
                    hidden={value !== index}
                    className="card-body"
                  >
                    <div className="card-header">{/* <FilterSection /> */}</div>
                    <BookingTable
                      bookings={paginatedBookings}
                      showActions={index === 0}
                      loading={loading}
                    />
                    <Box display="flex" justifyContent="end" my={2}>
                      <Pagination
                        count={Math.ceil(bookingData.length / itemsPerPage)}
                        page={currentPage}
                        onChange={(e, page) => setCurrentPage(page)}
                        color="primary"
                      />
                    </Box>
                  </div>
                ))}
              </Box>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default FlightBookingHistory;
